import React from "react";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
// import { isSp } from "../../common/userAgent"
// import { Link } from "../../lib/Link";
import Slider from "react-slick";
import { DynamicContent, isVisibleContent } from "../../common/DynamicContent";
import masterData from "../../lib/masterData";

export class TopGallery extends React.Component {
  state = {
    index: 0,
    galleryParams: [
      {
        imageSrcPc: "resource/img/topbk_b.png",
        imageSrcSp: "resource/img/topbks_b.png",
        linkHref: "/premiere/",
        external: true,
        text: "トランクハウス２４シリーズ　１軒家型の屋内収納スペース。無駄をなくしたスマート設計。環境になじんだシックな外観と、親しみやすくハローキティデザイン。",
        },
      {
        imageSrcPc: "resource/img/topbk_b.png",
        imageSrcSp: "resource/img/topbks_b.png",
        linkHref: "/premiere/",
        external: true,
        text: "トランクハウス２４シリーズ　１軒家型の屋内収納スペース。無駄をなくしたスマート設計。環境になじんだシックな外観と、親しみやすくハローキティデザイン。",
        },
    ],
  }
  constructor() {
    super();
    this.init();
  }
  async init() {
    await masterData.prepare('heroSlide');
    this.setState({
      galleryParams: masterData.heroSlide.filter(isVisibleContent),
    });
  }
  changeSlideindex(index) {
    this.refs.slider.slickGoTo(index);
  }
  onChangeIndex = (oldIndex, index) => {
    this.setState({ index });
  }
  render() {
    const { type } = this.props;
    return (
      <div className="TopGallery">
        <div className="galleryContainer">
        <Slider
          ref="slider"
          className="topSlider"
          infinite={true}
          speed={800}
          autoplaySpeed={4000}
          autoplay={true}
          slidesToShow={1}
          slidesToScroll={1}
          beforeChange={this.onChangeIndex}
          arrows={false}
          centerMode={true}
          variableWidth={true}
          arrows={this.props.type === TYPE_PC}
        >
          {this.state.galleryParams.map((params, index) => (
            <DynamicContent key={index} params={params} type={type} className="slide-content"/>
          ))}
        </Slider>
        <ul className="thumb-item">
          {this.state.galleryParams.map((params, index) => {
            const imageSrc =
            (this.props.type === TYPE_SP
              ? params.imageSrcSp
              : params.imageSrcPc) || params.imageSrc;
            return (
              <li key={index} className={this.state.index === index ? "current" : ""} onClick={() => this.changeSlideindex(index)}>
                <div className="overlay">
                  <img src={imageSrc}/>
                </div>
              </li>
            )
          })}
        </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/top/TopGallery.jsx